module.exports = __webpack_public_path__ + "img/natural-parallax.c27dbb92.jpg";